export interface Training {
  id: number
  title: string
  description: string
  meetingDate?: Date
}

export enum TrainingType {
  EPLI = 'EPLI',
  START = 'START'
}
